import { ChangeEvent, useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { HeroLayout } from 'component-library'

import LinkComponent from '../LinkComponent/LinkComponent'
import AddDataForm from '../AddDataForm/AddDataForm'

import homepageContent from '../../../content/homepage'

import './DatasetsHero.scss'

const { hero } = homepageContent

const DatasetsHero = () => {
  const [searchText, setSearchText] = useState('')

  return (
    <div className="DatasetsHero__wrapper" data-testid="datasets-hero">
      <HeroLayout
        title={hero.title}
        description={hero.description}
        ImageComponent={
          <div>
            <StaticImage
              src="https://assets.cloud.pennylane.ai/datasets/landing_page/Datasets_Hero_2024-01-11.png"
              alt=""
              loading="eager"
              placeholder="none"
              quality={100}
              className="hidden lg:!inline-block h-[300px] w-[460px]"
              data-testid="datasets-hero-image"
            />
          </div>
        }
        bottomContent={
          <div>
            <form action="/search" method="GET" role="form" className="mb-6">
              <div className="SearchBar">
                <input
                  className="SearchBar__input"
                  placeholder="Search"
                  value={searchText}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setSearchText(e.target.value)
                  }
                  name="q"
                />
                <input
                  name="contentType"
                  defaultValue="DATASET_FAMILY"
                  type="hidden"
                />
                <span className="SearchBar__action--left">
                  <i className="bx bx-search-alt-2" />
                </span>
                {searchText && (
                  <button
                    className="SearchBar__action--right"
                    aria-label="clear search"
                    type="button"
                    onClick={() => setSearchText('')}
                    data-testid="clear-search"
                  >
                    <i className="bx bx-x"></i>
                  </button>
                )}
              </div>
            </form>
            <div className="flex flex-col lg:!flex-row gap-4">
              <div className="flex flex-1">
                <AddDataForm className="w-full" />
              </div>
              {hero.link.url && hero.link.text && (
                <div className="flex flex-1">
                  <LinkComponent
                    href={hero.link.url}
                    className="Button Button-secondary w-full text-center !font-normal"
                  >
                    {hero.link.text}
                  </LinkComponent>
                </div>
              )}
            </div>
          </div>
        }
      />
    </div>
  )
}

export default DatasetsHero
